// extracted by mini-css-extract-plugin
module.exports = {"info":"tweet-info_info__AiKtR","infoLink":"tweet-info_infoLink__Ty7pE","infoIcon":"tweet-info_infoIcon__qNVaY"};